module.exports = __webpack_public_path__ + "img/609-42dfb3.png";